import { componentSizeMap } from '@zoryn/constants'

import type { ComponentSize } from '@zoryn/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
